<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
      color="primary"
      dark
    >
      <v-list nav dense>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-h6 font-weight-bold">
              {{ Profile }}
            </v-list-item-title>
            <v-list-item-subtitle>Admin Control Center</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mb-2" />
        <template v-for="item in items">
          <v-list-item
            v-if="!item.children"
            :key="item.title"
            :to="item.to"
            :exact="item.exact"
            link
            rounded
            class="main-nav-item"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title> <span class="v-nav-font">{{ item.title }}</span></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <template v-else>
            <v-divider
              v-if="item.dividerBefore"
              :key="`${item.title}-divider`"
              class="my-2"
            />
            <v-list-item
              :key="`${item.title}-header`"
              class="main-nav-item submenu-header"
              rounded
              :ripple="false"
            >
              <v-list-item-content>
                <v-list-item-title><span class="v-nav-font">{{ item.title }}</span></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list
              :key="`${item.title}-children`"
              dense
              nav
              class="submenu-list"
            >
              <v-list-item
                v-for="child in item.children"
                :key="child.title"
                :to="child.to"
                link
                rounded
                class="submenu-item"
              >
                <v-list-item-icon>
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title><span class="v-nav-font">{{ child.title }}</span></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </template>
        </template>
      </v-list>
      <template #append>
        <div class="pa-4">
          <v-btn block color="red" dark @click="handleLogout">
            Sign Out
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar app clipped-left style="background-color: #EBEBEB; color: #000;">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>
        <span class="v-head-font">Acdemic Service | {{ currentTitle }}</span>
      </v-toolbar-title>
      <v-spacer />
    </v-app-bar>

    <v-main>
      <v-container fluid class="py-6 px-6">
        <router-view />
      </v-container>
    </v-main>

    <v-footer app padless height="32" style="background-color: #EBEBEB;">
      <v-col class="text-center text-caption py-1" style="color: #000;">
        2025 - In-house MUIC
      </v-col>
    </v-footer>

    <v-snackbar v-model="snackbar" timeout="2000" color="info" top right>
      {{ snackbarMessage }}
    </v-snackbar>
  </v-app>
</template>

<script>
export default {
  name: 'AdminLayout',
  data: () => ({
    drawer: true,
    Profile: '',
    snackbar: false,
    snackbarMessage: '',
    items: [
      { title: 'รายการตรวจสอบ Avtivity', icon: 'mdi-view-dashboard', to: '/', exact: true },
      { title: 'Avtivity History', icon: 'mdi-format-list-checks', to: '/activitylist' },
      { title: 'ข้อมูล Lecturer', icon: 'mdi-account-group-outline', to: '/users' },
      { title: 'Reports', icon: 'mdi-file-chart', to: '/reports' },
      {
        title: 'Settings',
        icon: 'mdi-cog-outline',
        to: '/settings',
        dividerBefore: true,
        children: [
          { title: 'Activity Type Settings', to: '/settings/sub_setting_1', icon: 'mdi-tune' },
        ],
      },
    ],
  }),
  computed: {
    currentTitle() {
      const direct = this.items.find(item => item.to === this.$route.path)
      if (direct) {
        return direct.title
      }

      for (const item of this.items) {
        if (item.children) {
          const childMatch = item.children.find(child => child.to === this.$route.path)
          if (childMatch) {
            return childMatch.title
          }
        }
      }

      return 'Admin'
    },
  },
  mounted(){
    this.Profile = localStorage.getItem('username')
  },
  methods: {
    handleLogout() {
      // Use the global logoutAll function from main.js
      // It clears localStorage/sessionStorage, logs out from Keycloak or MSAL, and redirects to /login
      this.$logoutAll()
    },
  },
}
</script>

<style scoped>
.main-nav-item {
  min-height: 44px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.submenu-item {
  min-height: 40px;
  padding-left: 24px;
}

.submenu-header {
  font-weight: 600;
}

.submenu-list {
  padding-top: 0;
  padding-bottom: 0;
}
</style>
